{#if error}
    <div bind:this={modalContainer}>
        <Alert enabled={true} on:close={dismissError(error)} {...alertButtonText}>
            <div slot="body" class="plan-add-resource__error-modal-body">
                {error.body}
            </div>
        </Alert>
    </div>
{/if}

<script>
    import Alert from "@itslearning/prometheus/assets/modals/Alert/v1/Alert.svelte";
    import { afterUpdate, onDestroy } from "svelte";
    import { formatLanguageString } from "@itslearning/atlas/strings/format.js";

    export let i18n = {};
    export let idFocusedBeforeModal = "";
    export let planFilesStatusStore;

    let alertButtonText = {
        i18n: {
            CONFIRM: i18n.close
        }
    };

    let modalContainer;
    let error;

    $: errorCodes = new Map([
        ["invalidExtensionError", i18n.contentUploadHandlerFailure_InvalidFileExtension],
        ["invalidFileNameError", i18n.invalid_characters_file_name_X],
        ["invalidFileTypeError", i18n.file_upload_Invalid_file_type],
        ["nameTooLongError", i18n.contentUploadHandlerFailure_FileNameTooLong],
        ["tooLargeError", i18n.contentUploadHandlerFailure_FileSizeIsTooBig],
        ["tooSmallError", i18n.the_file_is_too_small],
        ["unknownError", i18n.contentUploadHandlerFailure_DefaultError]
    ]);

    const unsubscribeFromPlanFilesStatusStore = planFilesStatusStore.subscribe(statuses => {
        let fileError = null;

        for (const [fileName, file] of statuses) {
            if (file.error) {
                const fileErrorText = errorCodes.get(`${file.error}Error`);

                fileError = {
                    body: formatLanguageString(
                        i18n.quickAdd_FailedAddSingle,
                        fileName,
                        fileErrorText || i18n.contentUploadHandlerFailure_DefaultError
                    ),
                    file
                };

                break;
            }
        }

        error = fileError;
    });

    function dismissError({ file: { name } }) {
        planFilesStatusStore.dismissError(name);

        if (idFocusedBeforeModal) {
            document.querySelector(`button[id^=${idFocusedBeforeModal}]`).focus();
        }
    }

    afterUpdate(() => {
        if (error) {
            const buttons = modalContainer.querySelectorAll("button");

            if (buttons.length) {
                buttons[buttons.length - 1].focus();
            }
        }
    });

    onDestroy(unsubscribeFromPlanFilesStatusStore);
</script>
